export default __webpack_public_path__ + "static/media/start-live-session.c16ad9fe.svg";